export enum VerifyIdentityErrorScreenEnum {
  LinkExpired = 'LINK_EXPIRED',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  Error = 'ERROR',
}

export enum MagicLinkErrorCodes {
  LinkExpired = 6,
  TooManyRequests = 4,
}
